import { render, staticRenderFns } from "./TobaccoWarningDialog.vue?vue&type=template&id=2b14053b"
import script from "./TobaccoWarningDialog.vue?vue&type=script&lang=ts"
export * from "./TobaccoWarningDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports